import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Observable, ReplaySubject} from 'rxjs';
import {MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig} from '@angular/material/legacy-dialog';
import {MatLegacySnackBar as MatSnackBar, MatLegacySnackBarConfig as MatSnackBarConfig} from '@angular/material/legacy-snack-bar';
import {ActivatedRoute, Router} from '@angular/router';

import {ngcAnimations} from '@app/core/comp/animations';
import {AuthenticationService} from '@app/core/service/authentication.service';
import {ConfirmDialogComponent} from '@app/core/comp/dialog/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'ngc-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    animations : ngcAnimations
})
export class ForgotPasswordComponent implements OnInit {
    forgotPasswordForm: UntypedFormGroup;
    forgotPasswordFormErrors: any;
    isAccountSetup = false;

    loadingChange: ReplaySubject<boolean> = new ReplaySubject<boolean>();
    public loading: Observable<boolean> = this.loadingChange.asObservable();

    constructor(
        public snackBar: MatSnackBar,
        public dialog: MatDialog,
        public viewContainerRef: ViewContainerRef,
        private formBuilder: UntypedFormBuilder,
        public route: ActivatedRoute,
        public router: Router,
        private authService: AuthenticationService
    ) {
        this.forgotPasswordFormErrors = {
            email: {}
        };
    }

    ngOnInit() {
        this.route.data.subscribe((data: {accountSetup?: boolean}) => {
            this.isAccountSetup = !!data.accountSetup;
        });

        this.forgotPasswordForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email, Validators.pattern(RegExp('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,63}$', 'i'))]]
        });

        this.forgotPasswordForm.valueChanges.subscribe(() => {
            this.onForgotPasswordFormValuesChanged();
        });
    }

    onForgotPasswordFormValuesChanged() {
        for ( const field in this.forgotPasswordFormErrors ) {
            if ( !this.forgotPasswordFormErrors.hasOwnProperty(field) ) {
                continue;
            }

            // Clear previous errors
            this.forgotPasswordFormErrors[field] = {};

            // Get the control
            const control = this.forgotPasswordForm.get(field);

            if ( control && control.dirty && !control.valid ) {
                this.forgotPasswordFormErrors[field] = control.errors;
            }
        }
    }

    formSubmit() {
        const email = this.forgotPasswordForm.value['email'];

        this.loadingChange.next(true);
        this.authService.sendResetPasswordLink(email)
            .subscribe(
                data => {
                    this.loadingChange.next(false);
                    this.openSnackBar('Email has been sent.', '');

                    const config = new MatDialogConfig();
                    config.viewContainerRef = this.viewContainerRef;
                    config.autoFocus = false;
                    const dialogRef = this.dialog.open(ConfirmDialogComponent, config);
                    dialogRef.componentInstance.item = 'error';
                    dialogRef.componentInstance.header = 'Reset link has been sent';
                    dialogRef.componentInstance.target = 'Reset link has been sent. Check your email box.';
                    dialogRef.afterClosed().subscribe(result => {
                        this.router.navigate([`/login/vendor`]);
                    });
                    this.forgotPasswordForm.reset();
                },
                data => {
                    this.loadingChange.next(false);
                    this.openSnackBar('Reset password failed.', 'ERROR');
                    this.forgotPasswordForm.markAsPristine();
                    this.forgotPasswordForm.markAsUntouched();
                }
            );
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, <MatSnackBarConfig>{
            duration: 3000,
        });
    }
}
